export const getInvitationReminderEmailMarkup = (project_title) => `
<table class="module" role="module" data-type="text" border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;">
  <tr>
    <td style="padding:18px 0px 18px 0px;line-height:22px;text-align:inherit;" height="100%" valign="top" bgcolor="">
<p><span style="font-size:18px;"><span style="font-family:arial,helvetica,sans-serif;">This is a friendly reminder that you are invited to a new project,&nbsp;<strong>${project_title}</strong>. Make a quick visit to Dexter to learn more about the project opportunity and respond to the invitation before your spot is taken!</span></span></p>
    </td>
  </tr>
</table>
`
